import { Container } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';

import { DrilldownHeader } from '@components/DrilldownHeader';

import { getObservationConfig } from '@constants/fhir';

import { ParameterProvider } from '@contexts/index';

import AppLayout from '@layouts/AppLayout';

import { HEALTH_TRACKER_MAP } from '@models/vital-sign';
import type { TrackerType } from '@models/vital-sign';

import ReferenceRange from './ReferenceRange';

interface ParameterMainProps {
  category: TrackerType;
  code: string;
}

export default function ParameterMain({ category, code }: ParameterMainProps) {
  const { formatMessage } = useIntl();
  const { backRoute } = HEALTH_TRACKER_MAP[category];
  const METRIC_DATA = getObservationConfig(code);
  const label = METRIC_DATA?.messageId
    ? formatMessage({ id: METRIC_DATA.messageId })
    : '-';

  return (
    <AppLayout friendlyName={label}>
      <DrilldownHeader
        backRoute={`${backRoute}${code}`}
        showBackground
        title={label}
      />
      <Container>
        <ParameterProvider category={category} code={code}>
          <ReferenceRange />
        </ParameterProvider>
      </Container>
    </AppLayout>
  );
}
